import React, { memo } from 'react'
import * as styles from './inventoryAmounts.module.scss'

const InventoryAmounts = ({
   total = 0,
   inWarehouses = 0,
   pending = 0,
   loaned = 0,
   displayLoaned = true,
}: InventoryAmountsProps) => (
   <section className={styles.container}>
      <dl className={styles.statusList}>
         <div className={styles.statusRow}>
            <dt className={styles.statusLabel}>
               <span
                  className={`${styles.statusDot} ${styles.inWarehouses}`}
                  aria-hidden="true"
               ></span>{' '}
               In Warehouses
            </dt>
            <dd className={styles.statusValue}>{inWarehouses}</dd>
         </div>

         <div className={styles.statusRow}>
            <dt className={styles.statusLabel}>
               <span
                  className={`${styles.statusDot} ${styles.pending}`}
                  aria-hidden="true"
               ></span>{' '}
               Pending
            </dt>
            <dd className={styles.statusValue}>{pending}</dd>
         </div>

         {displayLoaned && (
            <div className={styles.statusRow}>
               <dt className={styles.statusLabel}>
                  <span
                     className={`${styles.statusDot} ${styles.loaned}`}
                     aria-hidden="true"
                  ></span>{' '}
                  Loaned
               </dt>
               <dd className={styles.statusValue}>{loaned}</dd>
            </div>
         )}

         <div className={`${styles.statusRow} ${styles.totalRow}`}>
            <dt className={styles.statusLabel}>Total Owned</dt>
            <dd className={styles.statusValue}>{total}</dd>
         </div>
      </dl>
   </section>
)

export default memo(InventoryAmounts)
